













import { Component, Vue } from "vue-property-decorator";
import { Content } from "@/interfaces/content";
import { mapState } from "vuex";
import ContentList from "@/components/ContentList.vue";

@Component({
  components: {
    ContentList
  },
  computed: {
    ...mapState(["purchases"])
  }
})
export default class Purchases extends Vue {
  // Mapped from vuex
  purchases!: Content[];

  mounted() {
    this.$Progress.finish();
  }
}
